import type { TFunction } from 'i18next';
import type { Arealplan, Planforhold } from '@origo/planregister';
import type { RelationPair } from '../types';
import { forholdtypeBadge } from '../codelists/forholdtype';
import { formatDateShortNb } from './formatDate';

interface PartyLookup {
    (napId: string): { plannavn: string; planId: string };
}

export function toRelationPair(
    relation: Planforhold,
    lookupParty: PartyLookup,
    t: TFunction
): RelationPair {
    const fromParty = lookupParty(relation.nasjonalArealplanIdFra);
    const toParty = lookupParty(relation.nasjonalArealplanIdTil);
    return {
        id: relation.relasjonId,
        from: fromParty,
        to: toParty,
        ikrafttredelsesdato: {
            label: formatDateShortNb(relation.vedtakEndeligPlanDato) ?? '—',
            variant: 'default',
        },
        type: forholdtypeBadge(relation.forholdtype, t),
        status: { label: t('codelists.planstatus.3'), variant: 'success' },
    };
}

export function buildPartyLookup(plans: Arealplan[]): PartyLookup {
    const map = new Map<string, { plannavn: string; planId: string }>();
    for (const plan of plans) {
        map.set(plan.nasjonalArealplanId, { plannavn: plan.plannavn, planId: plan.planId });
    }
    return (napId: string) => map.get(napId) ?? { plannavn: napId, planId: napId };
}
